export default "__VITE_ASSET__JTBiVJxW__"